import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FiltroPadraoService } from './../../../../services/filtro-padrao.service';
import { OnInit } from '@angular/core';
import { ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-enviar-feedback',
  templateUrl: './modal-enviar-feedback.component.html',
  styleUrls: ['./modal-enviar-feedback.component.scss']
})
export class ModalEnviarFeedbackComponent implements OnInit, OnDestroy {
  sendFeedbackForm: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl("", Validators.required),
  });
  selector: string;
  description: string = '';
  newSubs: Subscription;

  constructor(
    public modal: NgbActiveModal,
    private elemRef: ElementRef,
    private filtroPadraoService: FiltroPadraoService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { this.selector = this.elemRef.nativeElement.tagName.toLowerCase(); }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]["style"]["zoom"] = "0.85";
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  checkFields(formName: string): boolean {
    const value = this.sendFeedbackForm.get(formName)?.value;
    return !value || value.trim().length <= 5;
  }


  enviarFeedback(feedback): void {
    this.newSubs = this.filtroPadraoService.sendFeedbackFiltros({description: feedback})
      .subscribe(
        (result) => {
          this.toastr.show(this.translate.instant('FEEDBACK_ENVIADO_SUCESSO'), '', environment.toastrConfig('success'));
          this.modal.close(true);
        }, (error) => console.error('enviarFeedback', error)
      )
  }
}
